<template>
  <footer>
    <div class="footer-container">
      <div class="columns">
        <div class="column is-one-quarter">
          <p>
            © {{ currentYear }} PensExpert GmbH
          </p>
        </div>
        <div class="column is-half has-text-centered">
          <p>
            Service-Hotline: +49 6251 82756 0 (Mo-Fr 9-17 Uhr) | Service-E-Mail
            <a href="mailto:welcome@pensexpert.de">welcome@pensexpert.de</a>
          </p>
        </div>
        <div class="column is-one-quarter has-text-right">
          <nav>
            <a href="https://pensexpert.de/datenschutzerklaerung/">Datenschutz</a>
            <a href="https://pensexpert.de/impressum/">Impressum</a>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
</script>

<style lang="scss" scoped>
footer {
  background: white;
  padding: 2rem 0;
  margin-top: auto;

  .footer-container {
    max-width: 1500px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }

  .columns {
    margin-bottom: 0;
  }

  nav {
    a {
      margin-left: 1rem;
      color: #000;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .column {
      min-width: 100% !important;
      max-width: 100% !important;
      text-align: center !important;
    }

    nav a {
      margin: 0 0.5rem;
    }
  }
}
</style>
